// The shape this code reads and writes. Bump it with every change to the stored json, and add the step that gets there
export const PLAYBOOK_FORMAT = 1

interface Step {
  to: number
  silent: boolean                                   // true = the playbook behaves the same, so it can be saved right away
  note: string
  run: (playbook: any) => any
}

const STEPS: Step[] = [
  { to: 1, silent: true, note: "format number added; version and scripts dropped", run: ({ version, scripts, ...playbook }) => playbook },
]

export interface Migration {
  playbook: Playbook
  from: number
  changed: boolean
  silent: boolean
  notes: string[]
}

// Brings a stored playbook up to PLAYBOOK_FORMAT. Pure: it never saves, the caller decides what to do with the result
export function migrate(stored: any): Migration {
  const from = stored.format ?? 0
  if (from > PLAYBOOK_FORMAT) throw new Error(`the playbook has format ${from}, newer than this code (${PLAYBOOK_FORMAT})`)
  const steps = STEPS.filter(s => s.to > from)
  const playbook = steps.reduce((p, s) => ({ ...s.run(p), format: s.to }), structuredClone(stored))
  return { playbook, from, changed: !!steps.length, silent: steps.every(s => s.silent), notes: steps.map(s => s.note) }
}
